import { render, staticRenderFns } from "./MyPatients.vue?vue&type=template&id=5aa347b8&scoped=true&"
import script from "./MyPatients.vue?vue&type=script&lang=ts&"
export * from "./MyPatients.vue?vue&type=script&lang=ts&"
import style0 from "./MyPatients.vue?vue&type=style&index=0&id=5aa347b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa347b8",
  null
  
)

export default component.exports